<template>
  <div class="battle-container" :class="[zsTjTheme]">
    <div class="round">
      <Round
        :value="currentIndex"
        :roundInfos="roundInfos"
        @change="handleChangeIndex"
        @editTeam="handleEditTeam"
        :isEdit="isEdit"
      />
    </div>
    <div class="battle-main">
      <draggable
        v-if="hasCurrentBattleData"
        v-model="roundInfos[currentIndex].ourTeamData"
        :disabled="!isEdit"
        :handle="'.sort-item'"
        class="sort-team"
      >
        <div
          :class="['sort-item', getItemBg(item)]"
          v-for="(item, index) in filterRoundInfos[currentIndex].ourTeamData"
          :key="item.uniqueKey"
        >
          <img class="sort-img" :src="item.cover_url" alt="" />
          <div class="index">{{ index + 1 }}</div>
          <div class="name-line">
            {{
              item.actionType === "skills"
                ? item.currentSkin
                  ? item.currentSkin.name
                  : item.name
                : actionObj[item.actionType]
            }}
          </div>

          <template v-if="item.type === 'role'">
            <div
              v-if="item.actionType === 'skills' && item.currentSkin && item.currentSkin.skill_icon"
              class="skill-icon"
            >
              <img :src="item.currentSkin.skill_icon" alt="" />
            </div>
            <div v-if="item.actionType === 'damage' && item.damage_type" class="skill-icon gray">
              <img :src="item.damage_type" alt="" />
            </div>
            <div
              v-if="item.actionType === 'repel' && item.currentSkin && item.currentSkin.repel"
              class="skill-icon gray"
            >
              <img :src="item.currentSkin.repel" alt="" />
            </div>
            <div v-if="item.actionType === 'dead'" class="skill-icon gray">
              <img src="@/assets/zs_imgs/battle/battle_dead.webp" alt="" />
            </div>
          </template>
          <template v-else>
            <div class="skill-icon gray">
              <img v-if="item.actionType === 'skills' && item.skill_image" :src="item.skill_image" alt="" />
              <img v-if="item.actionType === 'damage' && item.damage_type" :src="item.damage_type" alt="" />
              <img v-if="item.actionType === 'repel' && item.repel" :src="item.repel" alt="" />
              <img v-if="item.actionType === 'dead'" src="@/assets/zs_imgs/battle/battle_dead.webp" alt="" />
            </div>
          </template>
        </div>
      </draggable>
      <div class="right-container">
        <div v-if="hasCurrentBattleData" class="role-container">
          <draggable
            v-model="roundInfos[currentIndex].battleData"
            :disabled="!isEdit"
            :handle="'.drag-item'"
            :forceFallback="true"
            :move="handleOurMove"
            @start="handleOurStart"
            @end="handleOurEnd"
            :class="['drag-list']"
          >
            <div
              v-for="(item, index) in filterRoundInfos[currentIndex].battleData"
              :key="index"
              :class="[
                'drag-bg',
                item.type === 0 ? 'no-card' : 'choosed-item',
                destIndex === index ? 'chosen-item' : ''
              ]"
            >
              <div class="drag-item" @click="handleEditRole(item, index)">
                <div v-if="item.type === 0" class="border-img-box">
                  <img src="@/assets/zs_imgs/battle/battle-normal.png" />
                </div>

                <template v-if="item.type !== 0">
                  <div v-if="item.type === 'role'" :class="['role-bg', getItemBg(item, 'w')]">
                    <img class="role-img" :src="item.cover_url" alt="" />
                    <div class="item-infos">
                      <div class="role-sp-box">
                        <div class="role-sp-line">
                          <template v-if="item.actionType !== 'skills' || !item.calcData || !item.calcData.sp">
                            <img class="item" src="@/assets/zs_imgs/battle/default_star.png" alt="default_star" />
                          </template>
                          <template v-else-if="item.calcData && item.calcData.sp && item.calcData.sp > 0">
                            <img
                              v-for="item in Number(item.calcData.sp)"
                              :key="item"
                              class="item"
                              src="@/assets/zs_imgs/battle/used_star.png"
                              alt="used_star"
                            />
                          </template>
                        </div>
                      </div>
                      <!-- <div class="index">{{ getRoleIndex(item.uniqueKey) }}</div> -->
                      <div v-if="item.type === 'role'" class="corner-icon">
                        <img :src="getCornerUrl(item)" alt="" />
                      </div>
                      <div
                        v-if="
                          item.currentStrengthen &&
                            item.currentStrengthen.name &&
                            strengthArr.includes(item.currentStrengthen.name)
                        "
                        class="strenth-icon"
                      >
                        <img :src="getStrenthUrl(item.currentStrengthen.name)" alt="" />
                      </div>
                      <div class="skill-icon">
                        <template v-if="item.type === 'role'">
                          <img
                            v-if="
                              item.actionType === 'skills' &&
                                (item.currentPotentialImage || (item.currentStrengthen && item.currentStrengthen.image))
                            "
                            :src="item.currentPotentialImage || item.currentStrengthen.image"
                            alt=""
                          />
                          <img
                            v-if="item.actionType === 'damage' && item.currentSkin && item.damage_type"
                            :src="item.damage_type"
                            alt=""
                          />
                          <img
                            v-if="item.actionType === 'repel' && item.currentSkin && item.currentSkin.repel"
                            :src="item.currentSkin.repel"
                            alt=""
                          />
                          <img
                            v-if="item.actionType === 'dead'"
                            src="@/assets/zs_imgs/battle/battle_dead.webp"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img v-if="item.actionType === 'skills' && item.skill_image" :src="item.skill_image" alt="" />
                          <img v-if="item.actionType === 'damage' && item.damage_type" :src="item.damage_type" alt="" />
                          <img v-if="item.actionType === 'repel' && item.repel" :src="item.repel" alt="" />
                          <img
                            v-if="item.actionType === 'dead'"
                            src="@/assets/zs_imgs/battle/battle_dead.webp"
                            alt=""
                          />
                        </template>
                      </div>

                      <!-- <div class="bottom-info">
                        <span v-if="item.type === 'role'" class="label">
                          {{
                            item.actionType === "skills"
                              ? item.currentSkin
                                ? item.currentSkin.name
                                : item.name
                              : actionObj[item.actionType]
                          }}
                        </span>
                        <span v-else class="label">
                          {{
                            item.actionType === "skills"
                              ? item.skill_name
                                ? item.skill_name
                                : item.name
                              : actionObj[item.actionType]
                          }}
                        </span>
                      </div> -->
                    </div>
                  </div>
                  <img v-else class="role-img" :src="item.cover_url" alt="" />
                </template>
                <!-- <template v-else>
                  <img
                    v-if="zsTjTheme == 'light'"
                    class="default-icon"
                    src="@/assets/zs_imgs/battle/light-our-team-icon.png"
                    alt=""
                  />
                </template> -->
              </div>
            </div>
          </draggable>
          <div class="arrow">
            <div class="bg"></div>
          </div>
        </div>
        <div v-if="!hasCurrentBattleData" class="empty-battle">
          <span class="text">{{ labelMap[currentIndex] }}{{ $t("tj.zs.hjzwtjzr") }}</span>
        </div>
      </div>
    </div>
    <div v-if="hasCurrentBattleData" class="sp-line">
      <div class="sp-icon"></div>
      <div class="title">
        <!-- 默认使用运营输入值，其次使用固定基础值减去消耗值 -->
        <span data-map-key="spCalcCount">
          {{ spCalcCount ? spCalcCount - usedSp : spUseBase[currentIndex] - usedSp }}
        </span>
        /
        <span class="total-sp" data-map-key="totalSp">{{ staticAllSp }}</span>
      </div>
      <BattleSpTip :usedSp="usedSp" :baseSp="spCalcCount ? Number(spCalcCount) : spUseBase[currentIndex]" />
      <div class="sp-container">
        <div v-for="item in spCalcDataCustom" :key="item.index" class="star-item">
          <img v-if="item.type === 'error'" src="@/assets/zs_imgs/battle/error_star.png" alt="error_star" />
          <img v-else-if="item.type === 'used'" src="@/assets/zs_imgs/battle/used_star.png" alt="used_star" />
          <img v-else-if="item.type === 'round'" src="@/assets/zs_imgs/battle/round_star.png" alt="round_star" />
          <img v-else src="@/assets/zs_imgs/battle/default_star.png" alt="" />
          <span v-if="isEdit">{{ item.index }}</span>
        </div>
      </div>
    </div>
    <div :class="['des', { view: !isEdit }, { edit: isEdit }]" @wheel.stop>
      <template v-if="isEdit">
        <div v-for="item in languageList" :key="item.code">
          <p>{{ item.name }}</p>
          <el-input
            type="textarea"
            :autosize="true"
            placeholder="批注内容"
            v-model="roundInfos[currentIndex].des[item.code]"
          ></el-input>
        </div>
      </template>

      <pre v-if="!isEdit && getCurrentLangValue(roundInfos[currentIndex].des).replace(/\s/g, '')">{{
        getCurrentLangValue(roundInfos[currentIndex].des)
      }}</pre>
    </div>

    <EditRole
      ref="editRoleRef"
      :roleList="roleList"
      :initRoleData="currentEditRoleData"
      @updateRole="handleUpdateRole"
      :choosedRoleCount="choosedRoleCount"
    />
    <EditTeam
      ref="editTemRef"
      :battleType="1"
      :current="filterRoundInfos[currentIndex]"
      :roleList="roleList"
      @updateTeam="handleUpdateTeam"
    />
    <ViewRole ref="roleInfoRef" :currentShowRoleData="currentShowRoleData" />
  </div>
</template>
<script>
import draggable from "vuedraggable";
import EditTeam from "./editTeam.vue";
import Round from "./round.vue";
import EditRole from "./editRole.vue";
import ViewRole from "./viewRole.vue";
import BattleSpTip from "./battleSpTip.vue";
import { apiGetBattleRoleList } from "@/api/wiki-zsca";
import { mapGetters } from "vuex";
import { createUniqueKey, v4 } from "@/plugins/util";
import langMap from "../../langMap";

export default {
  components: {
    draggable,
    EditTeam,
    Round,
    EditRole,
    ViewRole,
    BattleSpTip
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    currentShowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      actionObj: {
        skills: this.$t("tj.zs.jn"),
        damage: this.$t("tj.zs.gongji"),
        repel: this.$t("tj.zs.jt"),
        dead: this.$t("tj.zs.wfzd")
      },
      strengthArr: ["+0", "+1", "+2", "+3", "+4", "+5", "满破满潜力"],
      roleList: [], // 角色列表
      // 要交换的目标元素下标
      destIndex: -1,
      // 要交换的起始元素下标
      srcIndex: -1,
      currentIndex: 0,
      roundInfos: [],
      // 当前编辑的角色数据
      currentEditRoleIndex: -1,
      currentEditRoleData: {},
      totalSp: 0,
      currentShowRoleData: {},
      labelMap: {
        0: this.$t("tj.zs.tt"),
        1: "PVP",
        2: "BOSS"
      },
      spUseBase: {
        0: 15,
        1: 5,
        2: 15
      },
      spCalcCount: null,
      staticAllSp: "20"
    };
  },
  computed: {
    ...mapGetters(["zsTjTheme", "language", "languageList"]),
    // 本回合消耗的sp
    usedSp() {
      let sp = 0;
      const battleData = this.roundInfos[this.currentIndex].battleData || [];
      battleData.forEach(item => {
        if (item.calcData && item.calcData.sp) {
          // 回复的sp是留给下回合的，服装评测的阵容没有回合之说，所以不计算回复sp
          if (item.actionType === "skills") {
            sp += Number(item.calcData.sp);
          }
        }
      });
      return sp;
    },
    // 本回合是攻击和击退的角色
    currentDamageRoleLength() {
      const battleData = this.roundInfos[this.currentIndex].battleData || [];
      const result = battleData.filter(item => {
        if (item.type === "role" && (item.actionType === "damage" || item.actionType === "repel")) {
          return true;
        }
        return false;
      });
      return result.length;
    },
    // 本回合选了的角色数量
    choosedRoleCount() {
      const roleArr = this.roundInfos[this.currentIndex].battleData.filter(item => item.type !== 0);
      return roleArr ? roleArr.length : 0;
    },
    // 总共的sp
    allSp() {
      return Number(this.totalSp) + Number(this.currentDamageRoleLength);
    },
    spCalcData() {
      // 1 填充20个空数据的数组，
      let result = [];
      const len = 20;
      for (let i = 0; i < len; i++) {
        result.push({
          index: i + 1
        });
      }
      if (this.usedSp > this.allSp) {
        result = result.map((item, index) => {
          if (index < this.usedSp) {
            return {
              ...item,
              type: "error"
            };
          }
          return item;
        });
      } else if (this.usedSp === this.allSp) {
        result = result.map((item, index) => {
          if (index < this.usedSp) {
            return {
              ...item,
              type: "used"
            };
          }
          return item;
        });
      } else {
        result = result.map((item, index) => {
          if (index < this.usedSp) {
            return {
              ...item,
              type: "used"
            };
          } else if (index < this.allSp) {
            return {
              ...item,
              type: "round"
            };
          }
          return item;
        });
      }
      return result;
    },
    spCalcDataCustom() {
      /** 默认值 */
      let defCount = 20;
      /** 使用值 */
      let useCount = this.usedSp;
      /** 运营输入值 */
      let inputCount = this.spCalcCount;
      /** 剩余值 */
      let remaCount = inputCount === null ? this.spUseBase[this.currentIndex] - useCount : inputCount - useCount;

      const result = [];
      for (let index = 0; index < defCount; index++) {
        result.push({ type: "default" });
      }
      /** 基础SP值，SP点能到达的最大位置 */
      const maxCount = inputCount === null ? this.spUseBase[this.currentIndex] : Number(inputCount);
      /**
       * 如果剩余SP刚好为0，说明SP刚好都被消耗完，全部为已使用状态
       */
      if (remaCount === 0) {
        result.forEach((item, index) => {
          if (index < maxCount) {
            item.type = "used";
          }
        });
      }
      /**
       * 如果剩余SP大于0，则剩余值之前为未使用状态，之后到最大值之间为已使用状态
       */
      if (remaCount > 0) {
        result.forEach((item, index) => {
          if (index < remaCount) {
            item.type = "round";
            return;
          }
          if (index < maxCount) {
            item.type = "used";
          }
        });
      }
      /**
       * 如果剩余SP小于0，则全部为已使用状态，并且从尾部向前开始显示负数数量的状态（覆盖已使用状态）
       */
      if (remaCount < 0) {
        const roundCount = maxCount + remaCount;
        result.forEach((item, index) => {
          if (index < roundCount) {
            item.type = "used";
            return;
          }
          if (index < maxCount) {
            item.type = "error";
          }
        });
      }
      return result;
    },
    hasCurrentBattleData() {
      const result = this.roundInfos[this.currentIndex] && this.roundInfos[this.currentIndex].battleData;
      if (!result || !result.length) return false;
      return result.some(battle => battle.type !== 0);
    },
    // 处理阵容角色的多语言
    filterRoundInfos() {
      const { roleList, roundInfos } = this;
      if (!roleList || roleList.length === 0) return roundInfos;
      const newRoundInfos = roundInfos.map(round => {
        const newBattleData = this.getLanguageSetData(round.battleData);
        const newOurTeamData = this.getLanguageSetData(round.ourTeamData);
        return {
          ...round,
          battleData: newBattleData,
          ourTeamData: newOurTeamData
        };
      });
      // console.log("处理后的回合数据：", newRoundInfos);
      return newRoundInfos;
    }
  },
  watch: {
    currentShowData: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.battleData) {
          let parseData = JSON.parse(JSON.stringify(newVal.battleData));
          // console.log("当前回合数据：", parseData);
          // 找到当前回合数据不为空的index
          const findIndex = parseData.findIndex(
            item => item.battleData && item.battleData.some(item => item.type !== 0)
          );
          // 兼容老数据没有左侧排序数据
          parseData = parseData.map(item => {
            const obj = {
              ...item
            };
            if (!obj.ourTeamData || obj.ourTeamData.length === 0) {
              const filterData = obj.battleData.filter(i => i.type !== 0);
              obj.ourTeamData = filterData ? JSON.parse(JSON.stringify(filterData)) : [];
            }
            const des = obj.des;
            if (des) {
              if (typeof des === "object") {
                const res = {};
                this.languageList.forEach(lang => {
                  res[lang.code] = des[lang.code] || "";
                });
                obj.des = res;
              } else {
                // 老数据，是个字符串，默认赋值到zh-cn
                const res = {};
                this.languageList.forEach(lang => {
                  res[lang.code] = "";
                });
                res["zh-cn"] = des;
                obj.des = res;
              }
            } else {
              const res = {};
              this.languageList.forEach(lang => {
                res[lang.code] = "";
              });
              obj.des = res;
            }

            return obj;
          });
          this.roundInfos = parseData;
          // console.log("当前回合数据：", JSON.parse(JSON.stringify(this.roundInfos)));

          if (findIndex !== -1) {
            this.currentIndex = findIndex;
          } else {
            this.currentIndex = 0;
          }
          this.setSpCalcCount();
        } else {
          this.setInitRoundData();
        }
        if (newVal.totalSp) {
          this.totalSp = newVal.totalSp;
        } else {
          this.totalSp = 0;
        }
      }
    }
  },
  mounted() {
    // this.setInitRoundData();
    this.getRoleList();
  },
  methods: {
    // 获取角色列表
    getRoleList() {
      apiGetBattleRoleList().then(res => {
        if (res.code === 0) {
          if (res.data && (res.data.role || res.data.pet)) {
            const result = [];
            res.data.role &&
              res.data.role.forEach(item => {
                if (item.children) {
                  item.children.forEach(child => {
                    result.push({
                      ...child,
                      type: "role"
                    });
                  });
                }
              });
            res.data.pet &&
              res.data.pet.forEach(item => {
                result.push({
                  ...item,
                  id: item.name,
                  star: "pet",
                  type: "pet"
                });
              });
            this.roleList = result;
          }
        }
      });
    },
    setInitRoundData() {
      for (let i = 0; i < 3; i++) {
        const obj = {
          des: ``,
          battleData: [],
          ourTeamData: [],
          key: createUniqueKey()
        };
        let teamLength = 12;
        for (let i = 0; i < teamLength; i++) {
          obj.battleData.push({
            type: 0
          });
        }
        this.$set(this.roundInfos, i, obj);
      }
    },
    handleOurMove(e) {
      this.destIndex = e.draggedContext.futureIndex;
      return false;
    },
    handleOurStart(e) {
      this.srcIndex = e.oldIndex;
    },
    // 获取背景
    getItemBg(data, type = "") {
      if (data.type !== "role") return "";
      const endStr = type ? `-${type}` : "";
      if (langMap[data.attr] === "火") {
        return "red" + endStr;
      } else if (langMap[data.attr] === "光") {
        return "yellow" + endStr;
      } else if (langMap[data.attr] === "水") {
        return "blue" + endStr;
      } else if (langMap[data.attr] === "暗") {
        return "purple" + endStr;
      } else if (langMap[data.attr] === "风") {
        return "green" + endStr;
      }
      return "";
    },
    handleOurEnd(e) {
      if (this.destIndex === this.srcIndex || this.destIndex === -1) {
        return;
      }
      // 开始拖拽的元素和目标元素交换位置
      const lastItem = this.roundInfos[this.currentIndex].battleData[this.destIndex];
      const firstItem = this.roundInfos[this.currentIndex].battleData[this.srcIndex];
      this.roundInfos[this.currentIndex].battleData.splice(this.srcIndex, 1, lastItem);
      this.roundInfos[this.currentIndex].battleData.splice(this.destIndex, 1, firstItem);

      this.destIndex = -1;
    },
    // 编辑队伍
    handleEditTeam() {
      if (!this.isEdit) return;
      this.$refs.editTemRef.visible = true;
    },
    // 编辑角色
    handleEditRole(data, index) {
      if (!this.isEdit && data.type !== 0) {
        this.currentShowRoleData = data;
        this.$nextTick(() => {
          this.$refs.roleInfoRef.visible = true;
        });
        return;
      }
      if (!this.isEdit || data.type === 0) return;
      this.currentEditRoleIndex = index;
      this.currentEditRoleData = JSON.parse(JSON.stringify(data));
      if (!this.currentEditRoleData.v4) {
        this.currentEditRoleData.v4 = v4();
      }
      this.$nextTick(() => {
        this.$refs.editRoleRef.visible = true;
      });
    },
    // 更新角色
    handleUpdateRole(data) {
      const copyData = JSON.parse(JSON.stringify(data));
      const findPositionIndex = this.roundInfos[this.currentIndex].battleData.findIndex(
        i => i.uniqueKey === data.uniqueKey
      );
      this.$set(this.roundInfos[this.currentIndex].battleData, findPositionIndex, copyData);

      const findSortIndex = this.roundInfos[this.currentIndex].ourTeamData.findIndex(
        i => i.uniqueKey === data.uniqueKey
      );
      if (findSortIndex !== -1) {
        this.$set(this.roundInfos[this.currentIndex].ourTeamData, findSortIndex, copyData);
        console.log("更新了sort数据", this.roundInfos);
      }
    },
    handleChangeIndex(index) {
      this.currentIndex = index;
      this.setSpCalcCount();
    },
    // 更新队伍
    handleUpdateTeam(data) {
      const positionData = this.roundInfos[this.currentIndex].battleData;
      data.forEach(item => {
        const findIndex = positionData.findIndex(i => i.uniqueKey === item.uniqueKey);
        if (findIndex === -1) {
          const firstEmptyIndex = positionData.findIndex(i => i.type === 0);
          if (firstEmptyIndex !== -1) {
            this.$set(positionData, firstEmptyIndex, item);
          }
        }
      });
      // 过滤掉position中已经不在sort中的数据
      positionData.forEach((item, index) => {
        if (item.type !== 0 && !data.find(i => i.uniqueKey === item.uniqueKey)) {
          this.$set(positionData, index, {
            type: 0
          });
        }
      });
      this.$set(this.roundInfos[this.currentIndex], "battleData", positionData);
      this.$set(this.roundInfos[this.currentIndex], "ourTeamData", data);
    },
    // 获取强化图标
    getStrenthUrl(name) {
      if (name === "满破满潜力") {
        return require(`@/assets/zs_imgs/new_battle/strenth_full.webp`);
      }
      return require(`@/assets/zs_imgs/new_battle/strenth${name}.webp`);
    },
    // 获取角标图片
    getCornerUrl(item) {
      const star = parseInt(item.star);
      let potentialLength = item.currentPotential ? item.currentPotential.length : 0;
      if (potentialLength > 3) {
        potentialLength = 3;
      }
      if (star < 5) {
        if (potentialLength > 1) {
          potentialLength = 1;
        }
        return require(`@/assets/zs_imgs/new_battle/potential_${potentialLength}_star_34.png`);
      } else {
        return require(`@/assets/zs_imgs/new_battle/potential_${potentialLength}_star_5.png`);
      }
    },
    getRoleIndex(key) {
      const findIndex = this.roundInfos[this.currentIndex].ourTeamData.findIndex(item => item.uniqueKey === key);
      return findIndex === -1 ? 0 : findIndex + 1;
    },
    setSpCalcCount() {
      const value = this.roundInfos[this.currentIndex].spCalcCount;
      if (typeof value === "undefined") {
        this.spCalcCount = null;
      } else {
        this.spCalcCount = value;
      }
    },
    exposeSetBattleProp(key, value) {
      this.roundInfos[this.currentIndex][key] = value;
      this.setSpCalcCount();
    },
    getCurrentLangValue(data) {
      if (data) {
        if (typeof data === "string") {
          return data;
        }
        return this.language ? data[this.language] : "";
      }
      return "";
    },
    getLanguageSetData(data) {
      const { roleList } = this;
      return data.map(battle => {
        if (battle.type === "role") {
          const findRole = roleList.find(role => role.content_id === battle.content_id);
          if (findRole) {
            return this.getRoleLanguageSet(battle, findRole);
          }
        }
        return battle;
      });
    },
    getRoleLanguageSet(battle, findRole) {
      const { roleList } = this;
      const currentSkin =
        findRole.skin &&
        battle.currentSkin &&
        findRole.skin.find(skin => skin.name_code === battle.currentSkin.name_code);

      const currentSkills = currentSkin ? currentSkin.skills : null;
      const obj = {
        ...battle,
        currentSkin: currentSkin || battle.currentSkin,
        name: findRole.name,
        skin: findRole.skin || battle.skin || [] // 确保skin存在
      };
      // 服装强化对应的原始数据
      if (
        currentSkills &&
        currentSkills.strengthen &&
        currentSkills.strengthen.length &&
        battle.currentStrengthen &&
        battle.currentStrengthen.name
      ) {
        const findStrengthen = currentSkills.strengthen.find(str => str.name === battle.currentStrengthen.name);
        obj.currentStrengthen = findStrengthen || battle.currentStrengthen;
      }
      // 服装潜能对应的原始数据
      if (currentSkills && currentSkills.potential && currentSkills.potential.length && battle.currentPotential) {
        const filterPotential = battle.currentPotential.map(potential => {
          const findPotential = currentSkills.potential.find(pot => pot.name === potential.name);
          return findPotential || potential;
        });
        obj.currentPotential = filterPotential || [];
      }
      // 替补角色1
      if (battle.backup1) {
        const findRole = roleList.find(role => role.content_id === battle.backup1.content_id);
        if (findRole) {
          obj.backup1 = this.getRoleLanguageSet(battle.backup1, findRole);
        }
      }
      // 替补角色2
      if (battle.backup2) {
        const findRole = roleList.find(role => role.content_id === battle.backup2.content_id);
        if (findRole) {
          obj.backup2 = this.getRoleLanguageSet(battle.backup2, findRole);
        }
      }
      return obj;
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/views/wiki/tj/zs/view/components/battle.less";

.battle-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  background: rgba(63, 69, 83, 0.25);
  border-radius: 16px;
  margin: 50px 0;
  .round {
    flex: 0 0 auto;
    margin-bottom: 17px;
    padding-bottom: 16px;
  }
  .battle-main {
    width: 544px;
    margin: 0 auto 29px;
    display: flex;
    .sort-team {
      display: flex;
      flex-direction: column;
      flex: 0 0 auto;
      width: 112px;
      padding: 2px 0;
      margin-right: 18px;
      gap: 6px 0;
      box-sizing: border-box;
      .sort-item {
        position: relative;
        width: 100%;
        height: 63px;
        overflow: hidden;
        .sort-img {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 150%;
          height: 150%;
          object-fit: contain;
          transform: translate(-50%, -50%);
          user-select: none;
        }
        .name-line {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 92px;
          padding: 0 6px;
          height: 21px;
          line-height: 21px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .index {
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          left: 6px;
          top: 0;
          width: 20px;
          height: 22px;
          color: #fff;
          font-size: 14px;
          font-weight: 500;
          background: url("~@/assets/zs_imgs/battle/index_tag_bg.png") no-repeat;
          background-size: 100% 100%;
        }
        .skill-icon {
          position: absolute;
          top: 2px;
          right: 2px;
          width: 30px;
          height: 30px;
          padding: 1px;
          border-radius: 50%;
          background: rgba(216, 216, 216, 0.66);
          border: 1px solid #888888;
          &.gray {
            background: linear-gradient(to bottom, #525161, #9997af);
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 50%;
          }
        }
      }
    }
    .right-container {
      display: flex;
      flex-direction: column;
      flex: 1;
      .role-container {
        display: flex;
        width: 100%;
        .drag-list {
          flex: 1;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 7px;
          .drag-bg {
            width: 91px;
            height: 110px;
            position: relative;
            box-sizing: border-box;
            background-color: #151519;
            // 禁止选择
            user-select: none;
            transition: all ease;
            .drag-item {
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              // padding: 5px;
              box-sizing: border-box;
              cursor: pointer;
              .default-icon {
                width: 50px;
                height: 50px;
              }
              .role-bg {
                width: 100%;
                height: 100%;
                position: relative;
                overflow: hidden;
                .item-infos {
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 100%;
                  height: 100%;
                  box-sizing: border-box;
                  .index {
                    position: absolute;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    left: 0;
                    top: 0;
                    width: 22px;
                    height: 26px;
                    color: #fff;
                    font-size: 14px;
                    font-weight: 500;
                    background: url("~@/assets/zs_imgs/battle/index_tag_bg.png") no-repeat;
                    background-size: 100% 100%;
                  }
                  .strenth-icon {
                    position: absolute;
                    left: 0;
                    top: 2px;
                    width: 32px;
                    height: 24px;
                    img {
                      width: 100%;
                      height: 100%;
                      object-fit: cover;
                    }
                  }
                  .skill-icon {
                    display: flex;
                    position: absolute;
                    // top: 35px;
                    bottom: 17px;
                    left: 26px;
                    width: 36px;
                    height: 36px;
                    img {
                      width: 100%;
                      height: 100%;
                      object-fit: cover;
                    }
                  }
                  .corner-icon {
                    display: flex;
                    position: absolute;
                    // top: 35px;
                    top: 5px;
                    right: 5px;
                    width: 20px;
                    height: 20px;
                    img {
                      width: 100%;
                      height: 100%;
                      object-fit: cover;
                    }
                  }
                  .bottom-info {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    height: 25px;
                    padding: 3px 3px;
                    box-sizing: border-box;
                    background-color: rgba(34, 24, 21, 0.69);

                    .label {
                      // display: flex;
                      flex: 1;
                      color: #fff;
                      font-size: 12px;
                      text-align: center;
                      font-weight: 500;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                  }
                  .role-sp-box {
                    display: flex;
                    align-items: flex-end;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 58px;
                    padding-bottom: 6px;
                    background: linear-gradient(
                      180deg,
                      rgba(39, 49, 60, 0) 0%,
                      rgba(39, 49, 60, 0.47) 43%,
                      #27313c 100%
                    );
                    .role-sp-line {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      gap: 0 5px;

                      width: 100%;
                      height: 8px;
                    }
                    .item {
                      width: 8px;
                      height: 8px;
                    }
                  }
                }
              }
              .role-img {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -56%);
                width: 150%;
                height: 150%;
                object-fit: cover;
              }
              .border-img-box {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                padding: 3px;
                box-sizing: border-box;
              }
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .arrow {
          flex: 0 0 auto;
          display: flex;
          align-items: center;
          margin-left: 10px;
          .bg {
            width: 14px;
            height: 28px;
            background: url("~@/assets/zs_imgs/battle/battle_arrow_new.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }

      .empty-battle {
        position: relative;
        height: 360px;
        margin-bottom: 15px;
        background: url("~@/assets/zs_imgs/zbtj/empty-battle-bg1.png") center / contain no-repeat,
          url("~@/assets/zs_imgs/zbtj/empty-battle-bg2.png") center / contain no-repeat;
        .text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          font-size: 16px;
          white-space: nowrap;
        }
      }
    }
  }

  .sp-line {
    flex: 0 0 auto;
    display: flex;
    // flex-direction: column;
    align-items: center;
    width: 100%;
    height: 23px;
    padding-bottom: 12px;
    box-sizing: content-box;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);

    .total-sp {
      min-width: 20px;
    }
    .sp-icon {
      width: 24px;
      height: 24px;

      margin-right: 8px;
      background: url("~@/assets/zs_imgs/battle/sp_icon.png") no-repeat;
      background-size: 100% 100%;
    }
    .title {
      display: flex;
      align-items: center;
      margin-right: 6px;
      color: #333;
      font-size: 16px;
      font-weight: bold;
      line-height: 23px;
    }
    .sp-container {
      display: flex;
      align-items: center;
      gap: 0 6px;
      margin-left: 18px;
      .star-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 10px;
          height: 10px;
          margin-bottom: 2px;
        }
        span {
          color: #828ea0;
          font-size: 10px;
        }
      }
    }
  }

  .des {
    margin-top: 20px;
    &.view {
      flex: 1;
      overflow: auto;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &.edit {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: auto;
    }
    /deep/.el-textarea__inner {
      background: #1c232e;
      border: none;
      border-radius: 4px;
      color: #fff;
      &::placeholder {
        color: #5a606b;
      }
    }
    pre {
      margin: 0;
      padding: 0;
      color: #bbbbbb;
      font-size: 18px;
      // font-weight: 500;
      line-height: 24px;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }
}

.battle-container.light {
  // background: rgba(226, 231, 230, 0.73);
  background: none;
  .round {
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  }
  .battle-main {
    .sort-team {
      .sort-item {
        .name-line {
          background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, #222830 100%);
          color: #fff;
          font-size: 12px;
        }
      }
    }
    .right-container {
      .drag-list {
        .drag-bg {
          background-color: rgba(166, 171, 183, 0.4);
        }
      }
      .sp-line {
        background: rgba(166, 171, 183, 0.4);
        .title {
          color: #333;
        }
        .sp-container {
          .star-item {
            span {
              color: #484848;
            }
          }
        }
      }
    }
  }

  .des pre {
    color: #333;
  }
}
</style>
